module.exports = __webpack_public_path__ + "static/media/recorte-4.12ad9523.png";